export enum Equipment_Order_STATUSES {
  pending = 0,
  created = 1,
  takenCareByDept4 = 3,
  takenCareBySuperPharm = 4,
  // takenCareByDept5 = 5,
  denied = 80,
  finished = 8,
  supplied = 5,
  partialSupplied = 6,
  unknown = 100,
}
